// src/views/pending/PendingValidation.js
import React from 'react'
import { CCard, CCardBody, CContainer, CRow, CCol, CAlert, CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilCheckCircle, cilClock, cilEnvelopeClosed, cilBullhorn, cilPhone } from '@coreui/icons'
import { useNavigate } from 'react-router-dom'

const PendingValidation = () => {
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem('token')
    navigate('/login')
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8} lg={7} xl={6}>
            <div className="text-center mb-4">
              <div className="position-relative d-inline-block">
                <div
                  className="bg-info bg-opacity-10 rounded-circle p-4 d-inline-flex align-items-center justify-content-center"
                  style={{
                    width: '120px',
                    height: '120px',
                  }}
                >
                  <div className="position-relative">
                    <CIcon
                      icon={cilCheckCircle}
                      size="3xl"
                      className="text-info"
                      style={{
                        width: '50px',
                        height: '50px',
                        animation: 'float 6s ease-in-out infinite',
                      }}
                    />
                    <div className="processing-circle"></div>
                  </div>
                </div>
              </div>
            </div>

            <CCard className="border-0 shadow-sm">
              <CCardBody className="p-5">
                <h2 className="text-center mb-4 fw-bold">Compte en attente de validation</h2>

                <div className="text-center mb-4">
                  <div className="validation-progress mb-4">
                    <div className="progress-step completed">
                      <CIcon icon={cilEnvelopeClosed} />
                      <span>Demande reçue</span>
                    </div>
                    <div className="progress-line active"></div>
                    <div className="progress-step active">
                      <CIcon icon={cilClock} />
                      <span>En cours d'examen</span>
                    </div>
                    <div className="progress-line"></div>
                    <div className="progress-step">
                      <CIcon icon={cilCheckCircle} />
                      <span>Validation</span>
                    </div>
                  </div>

                  <p className="lead text-muted">
                    Votre demande d'inscription est en cours d'examen par l'équipe de modération.
                  </p>
                </div>

                <CAlert
                  color="info"
                  className="d-flex align-items-center mb-4 border-0 bg-info bg-opacity-10"
                >
                  <CIcon icon={cilBullhorn} className="flex-shrink-0 me-3 text-info" />
                  <div>
                    <h6 className="alert-heading mb-1">Que va-t-il se passer ?</h6>
                    <p className="mb-0">
                      Vous recevrez un email dès que votre compte sera validé. Vous pourrez alors
                      vous connecter et accéder à l'ensemble des fonctionnalités.
                    </p>
                  </div>
                </CAlert>

                <div className="border rounded-3 p-4 bg-light mb-4">
                  <h6 className="mb-3">En attendant, vous pouvez :</h6>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2 d-flex align-items-center">
                      <CIcon icon={cilPhone} className="text-primary me-2" />
                      Contacter notre équipe support
                    </li>
                    <li className="d-flex align-items-center">
                      <CIcon icon={cilEnvelopeClosed} className="text-primary me-2" />
                      Vérifier vos emails régulièrement
                    </li>
                  </ul>
                </div>

                <div className="d-grid">
                  <CButton
                    color="primary"
                    variant="ghost"
                    size="lg"
                    onClick={handleLogout}
                    className="btn-pill"
                  >
                    Retour à la page de connexion
                  </CButton>
                </div>
              </CCardBody>
            </CCard>

            <div className="text-center mt-4">
              <small className="text-muted">
                Une question ? N'hésitez pas à contacter notre support
              </small>
            </div>
          </CCol>
        </CRow>
      </CContainer>

      <style>
        {`
          @keyframes float {
            0% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
            100% {
              transform: translateY(0px);
            }
          }

          .processing-circle {
            position: absolute;
            top: -5px;
            left: -5px;
            right: -5px;
            bottom: -5px;
            border: 2px solid #0dcaf0;
            border-radius: 50%;
            animation: processing 1.5s linear infinite;
          }

          @keyframes processing {
            0% {
              transform: scale(1);
              opacity: 1;
            }
            100% {
              transform: scale(1.5);
              opacity: 0;
            }
          }

          .btn-pill {
            border-radius: 50px;
            padding: 12px 30px;
          }

          .btn:hover {
            transform: translateY(-2px);
            transition: transform 0.3s ease;
          }

          .validation-progress {
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 400px;
            margin: 0 auto;
          }

          .progress-step {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
            color: #8a93a2;
            width: 80px;
          }

          .progress-step.completed {
            color: #2eb85c;
          }

          .progress-step.active {
            color: #0dcaf0;
          }

          .progress-step span {
            font-size: 12px;
            text-align: center;
          }

          .progress-line {
            flex: 1;
            height: 2px;
            background-color: #8a93a2;
            margin: 0 10px;
          }

          .progress-line.active {
            background-color: #0dcaf0;
          }

          .list-unstyled li {
            margin-left: 8px;
          }
        `}
      </style>
    </div>
  )
}

export default PendingValidation
